const ClassName = {
	SHOWED: '_showed',
	ERROR: '_error',
};

class SignIn {
	constructor(el) {
		this.init(el);
	}

	init(el) {
		const container = el;

		if (!container) {
			return;
		}

		el.signIn = this;

		this.inputs = container.querySelectorAll('input[name="confirmation-code"]');

		const distributeCode = (code) => {
			const digits = code.split('').slice(0, inputs.length);

			digits.forEach((digit, i) => {
				if (digit.match(/^[0-9]$/)) {
					inputs[i].value = digit;
					inputs[i].dispatchEvent(new Event('input'));
				}
			});

			if (digits.length > 0) {
				const lastFilledIndex = Math.min(digits.length - 1, inputs.length - 1);
				inputs[lastFilledIndex].focus();
			}
		};

		this.inputs.forEach((input, index) => {
			input.addEventListener('input', (event) => {
				const value = event.target.value;

				if (value.length > 1) {
					distributeCode(value);
					event.target.value = '';
					return;
				}

				if (value.length === 1 && value.match(/^[0-9]$/)) {
					const nextInput = this.inputs[index + 1];
					if (nextInput) {
						nextInput.focus();
					}
				} else {
					event.target.value = '';
				}
			});

			input.addEventListener('keydown', (event) => {
				if (event.key === 'Backspace' && input.value === '' && index > 0) {
					this.inputs[index - 1].focus();
				}
			});

			input.addEventListener('paste', (event) => {
				event.preventDefault();
				const pasteData = event.clipboardData
					.getData('text')
					.replace(/\D/g, '');
				if (pasteData) {
					distributeCode(pasteData);
				}
			});
		});
	}
	showWarning(text) {
		const container = document.querySelector('[data-sign-in]').parentElement;
		const warningEl = container?.querySelector('.popup__toast._warning');

		if (!container || !warningEl) {
			return;
		}

		warningEl.querySelector('.popup__toast-text').textContent = text;

		warningEl.classList.add(ClassName.SHOWED);
		this.inputs.forEach((input) => {
			const inputContainer = input.closest('[data-input]');
			inputContainer.customInput.setValue('');
			this.inputs[0].focus();
			inputContainer.classList.add(ClassName.ERROR);
		});
		setTimeout(() => {
			warningEl.classList.remove(ClassName.SHOWED);
			this.inputs.forEach((input) => {
				const inputContainer = input.closest('[data-input]');
				inputContainer.classList.remove(ClassName.ERROR);
			});
		}, 3000);
	}
}

document.querySelectorAll('[data-sign-in]').forEach((el) => new SignIn(el));

export default SignIn;
